export const SHOW_MODAL = 'SHOW_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

export const showBanner = () => ({ type: SHOW_MODAL, banner: true });
export const showSermonNotes = ({ sermon }) => ({ type: SHOW_MODAL, sermon });
export const showYouTube = ({ youtubeId }) => ({ type: SHOW_MODAL, youtubeId });
export const closeModal = () => ({ type: CLOSE_MODAL });
